<!--赖传峰-->
<!--2022/4/11-->
<script
  lang="ts"
  setup
>
import {
  computed,
  useI18n,
  watch,
} from '#imports'
import PPButton from '@/components/PPButton.vue'
import PremiumRights from '@/components/share/premium-rights/PremiumRights.vue'
import { useLayout } from '@/store/layout'
import { useShare } from '@/store/share'
import { useUserInfo } from '@/store/userInfo'
import { RoutePathOfDrive } from '@/types/enum'
import qs from 'qs'
import { useWebDecompression } from './fileExplorer.script'

const { t } = useI18n()
const shareStore = useShare()
const premium = computed(() => useUserInfo().premium)
const isMobile = computed(() => useLayout().isMobile)

const close = () => shareStore.fileSpaceNotEnoughVisible = false

const getShareIdFromPathname = () => window.location.pathname.split('/')[2]

const paymentLink = computed(() => `${premium.value
  ? RoutePathOfDrive.PAYMENT_STORAGE
  : RoutePathOfDrive.PAYMENT}?${qs.stringify({
  refer_from: 'v_web_pikpak_ggong_share_space_limit',
  action: 'close',
  share_id: getShareIdFromPathname(),
  share_userid: shareStore.data?.user_info?.user_id,
})}`)

// 非会员的卡点提示弹出改成引导支付弹窗
const { show: showPaymentPane } = useWebDecompression()
watch(() => shareStore.fileSpaceNotEnoughVisible, (visible) => {
  if (import.meta.server || !visible) return
  if (!premium.value) {
    const origin = window.location.origin
    showPaymentPane(`${origin}/drive/payment/join-vip?title=${encodeURIComponent(t('request-payment-limit-storage'))}&initialIndex=1&referfrom=v_web_pikpak_hytq_space_limit&aidfrom=share_page`)
  }
})
</script>

<template>
  <ElDialog
    v-if="premium"
    v-model="shareStore.fileSpaceNotEnoughVisible"
    :class="premium ? 'space-not-enough' :'space-not-enough not-premium'"
    :title="$t('file-space-not-enough-title')"
    append-to-body
    width="640px"
  >
    <div v-if="!premium && isMobile">
      <div class="mobile-dialog-header">
        <a @click="close">
          {{ $t('close') }}
        </a>
      </div>
      <div class="title">
        {{ $t('file-space-not-enough-title') }}
      </div>
    </div>
    <div>
      <div class="subtitle">
        {{
          premium
            ? $t('premium-file-space-not-enough-subtitle')
            : $t('file-space-not-enough-subtitle')
        }}
      </div>
    </div>
    <PremiumRights v-if="!premium" />
    <template #footer>
      <ElButton
        v-if="!(isMobile && !premium)"
        style="color:var(--color-secondary-text); margin-right: 12px"
        text
        @click="close"
      >
        {{ premium ? $t('cancel') : $t('not-open') }}
      </ElButton>
      <a
        :href="paymentLink"
        style="text-decoration: none"
        target="_blank"
      >
        <PPButton :class="premium ? 'premium-confirm-btn': 'not-premium-confirm-btn'">
          {{ premium ? $t('buy-space') : $t('confirm-open') }}
        </PPButton>
      </a>
    </template>
  </ElDialog>
</template>

<style
  lang="less"
  scoped
>
.premium-confirm-btn {
  background: var(--color-premium);
  border-color: var(--color-premium);

  &:hover {
    border-color: var(--color-premium);
  }
}

</style>

<style lang="less">
@import '@/assets/styles/util.less';

.space-not-enough {
  .subtitle {
    color: #ff663b
  }

  &.not-premium {
    background: linear-gradient(347.81deg, #ecf7ff 24.57%, #dcefff 102.72%);
    @media screen and (max-width: @mobile-break-width) {
      #mobile-fullscreen-dialog();

      .mobile-dialog-header {
        border-color: #e3e7eb;
      }

      .title {
        line-height: 28px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        margin-top: 30px;
        color: #000;
      }

      .subtitle {
        text-align: center;
        margin-top: 8px;
      }

      .not-premium-confirm-btn {
        #mobile-block-btn();
      }
    }
  }
}

</style>
